import { getconfig } from '@/api/init';
import { setSessionStorage, getSessionStorage } from '@/utils/stage';

const state = {
	web_title: '',
	yd_product_id: '',
	captcha_id: '',
	data_uuid: '',
};
const mutations = {
	SET_WEBTITLE: (state, token) => {
		state.web_title = token;
	},
	SET_PRODUCT: (state, token) => {
		state.yd_product_id = token;
	},
	SET_CAPTCHAID: (state, token) => {
		state.captcha_id = token;
	},
	SET_DATAUUID: (state, token) => {
		state.data_uuid = token;
	},
};
const actions = {
	setWebtitle({ commit }, data) {
		commit('SET_WEBTITLE', data);
	},
	getGameInfo({ commit }) {
		return new Promise((resolve, reject) => {
			let YOUR_PRODUCT_NUMBER = '';
			let wm = null;
			const configData = getSessionStorage('message');
			getconfig(configData)
				.then((res) => {
					setSessionStorage('configInit', JSON.stringify(res.data));
					commit('SET_PRODUCT', res.data.yd.product_id);
					commit('SET_CAPTCHAID', res.data.yd.captcha_id);
					commit('SET_DATAUUID', res.data.data_uuid);
					YOUR_PRODUCT_NUMBER = res.data.yd.product_id;
				})
				.then(() => {
					// 初始化SDK，只需初始化一次
					if (YOUR_PRODUCT_NUMBER) {
						initWatchman({
							productNumber: YOUR_PRODUCT_NUMBER,
							onload: function (instance) {
								wm = instance;
								console.log(wm);
								window.wm = wm;
							},
						});
					} else {
						window.wm = null;
					}
					resolve();
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
};
export default {
	namespaced: true,
	state,
	mutations,
	actions,
};
